import HTTP from '@/plugins/http';

const channelApi = {
  userAdd: '/channelAccountConf/create',
  userPage: '/channelAccountConf/page',
  userUpdate: '/channelAccountConf/update',
  channelType: '/channelType/page',
  updateChannelType: '/channelType/update',
  confAdd: '/channelConf/create',
  confPage: '/channelConf/page',
  confType: '/channelConf/support',
  confUpdate: '/channelConf/update',
  test: '/channel/test',
  testUsdt: '/channel/usdt/test',
  checkoutTest: '/channel/counter/test',
  channelList: '/channel/merchant/channel/list',
  updateChannel: '/channel/merchant/channel/update',
  thirdChannel: '/channel/seeting/page',
  updateThirdChannel: '/channel/seeting/update',
  bankCode: '/channel/payout/support',
  testPayout: '/channel/payout/test',
  bankchannelList: '/channel/merchant/bankChannel/list',
  updatebankChannel: '/channel/merchant/bankChannel/update',
  updateBatch: 'channelType/updateBatch'
};

function userAdd(params) {
  return HTTP({
    url: channelApi.userAdd,
    method: 'post',
    data: params
  });
}
function getPage({ data, params }) {
  return HTTP.loading({
    url: channelApi.userPage,
    method: 'post',
    data: { query: data, ...params }
  });
}

function getChannelPage({ data }) {
  return HTTP.loading({
    url: channelApi.channelType,
    method: 'post',
    data
  });
}

function userUpdate(params) {
  return HTTP({
    url: channelApi.userUpdate,
    method: 'post',
    data: params
  });
}
function confAdd(params) {
  return HTTP({
    url: channelApi.confAdd,
    method: 'post',
    data: params
  });
}
function confPage({ data, params }) {
  return HTTP({
    url: channelApi.confPage,
    method: 'post',
    data,
    params
  });
}
function confType() {
  return HTTP({
    url: channelApi.confType,
    method: 'get',
    'content-type': 'application/x-www-form-urlencoded'
  });
}
function doTest(data) {
  let url;
  if (data.type == 'usdt_qr') {
    url = channelApi.testUsdt;
  } else if (data.type == 'payout') {
    url = channelApi.testPayout;
  } else {
    url = channelApi.test;
  }

  return HTTP.loading({
    // url: data.type != 'usdt_qr' ? channelApi.test : channelApi.testUsdt,
    url: url,
    method: 'post',
    data
  });
}
function confUpdate(params) {
  return HTTP({
    url: channelApi.confUpdate,
    method: 'post',
    data: params
  });
}

function channelUpdate(params) {
  return HTTP({
    url: channelApi.updateChannelType,
    method: 'post',
    data: params
  });
}

function doCheckTest(data) {
  return HTTP.loading({
    url: channelApi.checkoutTest,
    method: 'post',
    data
  });
}

function getMerchantChannelList(data) {
  return HTTP.loading({
    url: channelApi.channelList,
    method: 'post',
    data
  });
}

function updateChannelList(data) {
  return HTTP({
    url: channelApi.updateChannel,
    method: 'post',
    data
  });
}

function getThirdChannelList(data) {
  return HTTP.loading({
    url: channelApi.thirdChannel,
    method: 'post',
    data
  });
}

function updateThirdChannelList(data) {
  return HTTP({
    url: channelApi.updateThirdChannel,
    method: 'post',
    data
  });
}

function bankCodeList() {
  return HTTP({
    url: channelApi.bankCode,
    method: 'get'
  });
}

function getMerchantBankChannelList(data) {
  return HTTP.loading({
    url: channelApi.bankchannelList,
    method: 'post',
    data
  });
}

function updatebankChannelList(data) {
  return HTTP({
    url: channelApi.updatebankChannel,
    method: 'post',
    data
  });
}

function updateBatch(data) {
  return HTTP({
    url: channelApi.updateBatch,
    method: 'post',
    data
  });
}

export default {
  userAdd,
  getPage,
  userUpdate,
  confAdd,
  confPage,
  confType,
  confUpdate,
  doTest,
  getChannelPage,
  channelUpdate,
  doCheckTest,
  getMerchantChannelList,
  updateChannelList,
  getThirdChannelList,
  updateThirdChannelList,
  bankCodeList,
  getMerchantBankChannelList,
  updatebankChannelList,
  updateBatch
};



// WEBPACK FOOTER //
// ./src/api/channel.js